import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Box,
  Chip,
  Tooltip,
  Checkbox,
} from "@mui/material";
import { Link } from "@mui/material";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { getContractField, getStatusColor } from "../../functions";
import currency from "currency.js";

const FinancingTable = ({ loading, filteredContracts }) => {
  const navigate = useNavigate();

  return (
    <TableContainer component={Paper} sx={{ maxHeight: "calc(100vh - 350px)" }}>
      <Table stickyHeader size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }} rowSpan={2}>Código</TableCell>
            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }} rowSpan={2}>Tipo</TableCell>
            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }} rowSpan={2}>Contratista</TableCell>
            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }} rowSpan={2}>Cédula</TableCell>
            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }} rowSpan={2}>Correo</TableCell>
            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }} rowSpan={2}>Supervisor(es)</TableCell>
            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }} rowSpan={2}>Objeto</TableCell>
            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }} align="right" rowSpan={2}>Valor</TableCell>
            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }} align="center" rowSpan={2}>Duración</TableCell>
            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }} align="center" rowSpan={2}>F. Inicio</TableCell>
            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }} align="center" rowSpan={2}>F. Cierre</TableCell>
            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }} rowSpan={2}>Dependencia</TableCell>
            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }} rowSpan={2}>Naturaleza</TableCell>
            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }} align="center" rowSpan={2}>Estado</TableCell>
            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }} colSpan={3} align="center">Novedades</TableCell>
            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }} colSpan={2} align="center">Anexos</TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#e8e8e8', fontSize: '0.7rem', py: 0.5 }} align="center">Tipo</TableCell>
            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#e8e8e8', fontSize: '0.7rem', py: 0.5 }} align="center">F. Inicio</TableCell>
            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#e8e8e8', fontSize: '0.7rem', py: 0.5 }} align="center">F. Fin</TableCell>
            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#e8e8e8', fontSize: '0.7rem', py: 0.5 }} align="center">SECOP</TableCell>
            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#e8e8e8', fontSize: '0.7rem', py: 0.5 }} align="center">CDP/CRP</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell colSpan={18} align="center" sx={{ py: 4 }}>
                Cargando contratos...
              </TableCell>
            </TableRow>
          ) : filteredContracts.length === 0 ? (
            <TableRow>
              <TableCell colSpan={18} align="center" sx={{ py: 4 }}>
                No se encontraron contratos
              </TableCell>
            </TableRow>
          ) : (
            [...filteredContracts].sort((a, b) => (a.contractCode || "").localeCompare(b.contractCode || "")).map((contract, index) => {
              const getContractFieldWithNews = getContractField(
                contract.news || [],
                {
                  status: contract.status,
                  finishedAt: contract.finishedAt,
                  contractPeriod: contract.contractPeriod,
                  contractBudget: contract.contractBudget,
                  startedAt: contract.startedAt,
                  supervisors: contract.supervisors,
                  salary: contract.salary,
                  tasks: contract.tasks,
                }
              );

              return (
                <TableRow
                  key={contract.contractId || index}
                  sx={{
                    "&:hover": { backgroundColor: "#f9f9f9" },
                    "&:nth-of-type(even)": { backgroundColor: "#fafafa" },
                  }}
                >
                  <TableCell>
                    <Link
                      component="button"
                      variant="body2"
                      onClick={() =>
                        navigate(`/contracts/${contract.contractCode}`)
                      }
                      sx={{
                        fontWeight: 500,
                        textDecoration: "none",
                        cursor: "pointer",
                        "&:hover": { textDecoration: "underline" },
                      }}
                    >
                      {contract.contractCode || "--"}
                    </Link>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                      {contract.contractType || "--"}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2">
                      {contract.contractor
                        ? `${contract.contractor.name || ""} ${
                            contract.contractor.lastName || ""
                          }`
                        : "Sin asignar"}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2">
                      {contract.contractorNuip || "--"}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                      {contract.contractor?.email || "--"}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Box sx={{ maxWidth: 200 }}>
                      {contract.supervisors?.length > 0 ? (
                        contract.supervisors.map((sup, i) => (
                          <Typography
                            key={i}
                            variant="body2"
                            sx={{ fontSize: "0.75rem" }}
                          >
                            {`${sup.name || ""} ${sup.lastName || ""}`}
                          </Typography>
                        ))
                      ) : (
                        <Typography variant="body2" color="text.secondary">
                          --
                        </Typography>
                      )}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Tooltip title={contract.contractSubject || ""}>
                      <Typography
                        variant="body2"
                        sx={{
                          maxWidth: 300,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          fontSize: "0.75rem",
                        }}
                      >
                        {contract.contractSubject || "--"}
                      </Typography>
                    </Tooltip>
                  </TableCell>
                  <TableCell align="right">
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      {currency(
                        getContractFieldWithNews("contractBudget")
                      ).format()}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body2">
                      {(() => {
                        const period =
                          getContractFieldWithNews("contractPeriod");
                        return period ? `${period} días` : "--";
                      })()}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                      {contract.startedAt
                        ? moment(
                            contract.startedAt.toDate
                              ? contract.startedAt.toDate()
                              : contract.startedAt
                          ).format("DD/MM/YYYY")
                        : "--"}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                      {(() => {
                        const finishedAt =
                          getContractFieldWithNews("finishedAt");
                        return finishedAt
                          ? moment(
                              finishedAt.toDate
                                ? finishedAt.toDate()
                                : finishedAt
                            ).format("DD/MM/YYYY")
                          : "--";
                      })()}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                      {contract.dependency || "--"}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                      {contract.nature || "--"}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Chip
                      label={contract.status || "--"}
                      color={getStatusColor(contract.status)}
                      size="small"
                      sx={{ fontSize: "0.7rem" }}
                    />
                  </TableCell>
                  <TableCell>
                    {contract.news && contract.news.length > 0 ? (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 0.5,
                        }}
                      >
                        {contract.news.map((news, idx) => (
                          <Typography
                            key={idx}
                            variant="body2"
                            sx={{ fontSize: "0.7rem" }}
                          >
                            {news.type || "--"}
                          </Typography>
                        ))}
                      </Box>
                    ) : (
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ fontSize: "0.7rem" }}
                      >
                        --
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell>
                    {contract.news && contract.news.length > 0 ? (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 0.5,
                        }}
                      >
                        {contract.news.map((news, idx) => (
                          <Typography
                            key={idx}
                            variant="body2"
                            sx={{ fontSize: "0.7rem" }}
                          >
                            {news.startedAt
                              ? moment(
                                  news.startedAt.toDate
                                    ? news.startedAt.toDate()
                                    : news.startedAt
                                ).format("DD/MM/YYYY")
                              : "--"}
                          </Typography>
                        ))}
                      </Box>
                    ) : (
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ fontSize: "0.7rem" }}
                      >
                        --
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell>
                    {contract.news && contract.news.length > 0 ? (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 0.5,
                        }}
                      >
                        {contract.news.map((news, idx) => (
                          <Typography
                            key={idx}
                            variant="body2"
                            sx={{ fontSize: "0.7rem" }}
                          >
                            {news.finishedAt
                              ? moment(
                                  news.finishedAt.toDate
                                    ? news.finishedAt.toDate()
                                    : news.finishedAt
                                ).format("DD/MM/YYYY")
                              : "--"}
                          </Typography>
                        ))}
                      </Box>
                    ) : (
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ fontSize: "0.7rem" }}
                      >
                        N/A
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell align="center">
                    <Checkbox
                      checked={
                        contract.annexes?.some((a) =>
                          a.name?.toLowerCase().includes("secop")
                        ) || false
                      }
                      disabled
                      size="small"
                    />
                  </TableCell>
                  <TableCell align="center">
                    <Checkbox
                      checked={
                        contract.annexes?.some((a) =>
                          a.name?.toLowerCase().includes("cdp y crp")
                        ) || false
                      }
                      disabled
                      size="small"
                    />
                  </TableCell>
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default FinancingTable;
